var map = {
	"./Home": 2822,
	"./Home.tsx": 2822,
	"./error/ErrorBoundary": 20488,
	"./error/ErrorBoundary.tsx": 20488,
	"./error/NotFound": 14618,
	"./error/NotFound.tsx": 14618,
	"./layouts/Footer": 62226,
	"./layouts/Footer.tsx": 62226,
	"./layouts/Header": 60464,
	"./layouts/Header.tsx": 60464,
	"./layouts/MainLayout": 73723,
	"./layouts/MainLayout.tsx": 73723,
	"./views/Agreement": 14938,
	"./views/Agreement.tsx": 14938,
	"./views/BattlePass": 17342,
	"./views/BattlePass.tsx": 17342,
	"./views/Blog": 61003,
	"./views/Blog.tsx": 61003,
	"./views/Contacts": 31657,
	"./views/Contacts.tsx": 31657,
	"./views/Contract": 65585,
	"./views/Contract.tsx": 65585,
	"./views/Event": 61678,
	"./views/Event.tsx": 61678,
	"./views/Faq": 55784,
	"./views/Faq.tsx": 55784,
	"./views/LiveTrades": 13674,
	"./views/LiveTrades.tsx": 13674,
	"./views/Odds": 79153,
	"./views/Odds.tsx": 79153,
	"./views/Pay": 67839,
	"./views/Pay.tsx": 67839,
	"./views/Play": 1943,
	"./views/Play.tsx": 1943,
	"./views/Post": 7071,
	"./views/Post.tsx": 7071,
	"./views/PrivacyPolicy": 46207,
	"./views/PrivacyPolicy.tsx": 46207,
	"./views/Profile": 96813,
	"./views/Profile.tsx": 96813,
	"./views/ProvablyFair": 47622,
	"./views/ProvablyFair.tsx": 47622,
	"./views/Refunds": 77063,
	"./views/Refunds.tsx": 77063,
	"./views/Search": 44337,
	"./views/Search.tsx": 44337,
	"./views/Settings": 35370,
	"./views/Settings.tsx": 35370,
	"./views/Upgrade": 45883,
	"./views/Upgrade.tsx": 45883,
	"./views/User": 56052,
	"./views/User.tsx": 56052,
	"./views/Wheel": 79407,
	"./views/Wheel.tsx": 79407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 51691;
module.exports = webpackContext;